import React from 'react'

function ContactUs({text_arg}) {
  let text = text_arg || "Contact us for more!"

  return (
    <h5 className="has-text-weight-bold is-size-5 honey-text-font-family-common honey-text-common honey-heading-contact-us">
      <a target="_blank" rel="noopener noreferrer" href="mailto:info@honeyshare.live">{text}</a>
      &nbsp;
      <a target="_blank" rel="noopener noreferrer" href="mailto:info@honeyshare.live"><i className="fa-solid fa-envelope"></i></a>
    </h5>
  );
}

export default ContactUs;
